import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'

// Employee endpoint - get my own submissions
const getMySubmissions = (): Promise<AxiosResponse> => {
  return Request.get('/mobile/reimbursements/receipts/')
}

// Admin endpoint - get all employee submissions
const getAllEmployeeSubmissions = (): Promise<AxiosResponse> => {
  return Request.get('/hr/reimbursement/receipts/')
}

const getEmployeeSubmissions = (employeeId: string): Promise<AxiosResponse> => {
  return Request.get(`/hr/reimbursement/receipts/?employee=${employeeId}`)
}

// Admin endpoint - get receipt details
const getReceiptDetails = (receiptId: string): Promise<AxiosResponse> => {
  return Request.get(`/hr/reimbursement/receipts/${receiptId}/details/`)
}

export default {
  getMySubmissions,
  getAllEmployeeSubmissions,
  getEmployeeSubmissions,
  getReceiptDetails,
}
